import {NutakuPaymentBrowserService} from "../../../services/payments/NutakuPaymentBrowserService";
import {useActions} from "../../../hooks/useActions";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {config} from "../../../config";

function NutakuBox({box}: any) {
    const {setIsLoading, updateUser} = useActions();
    const {isLoading} = useTypedSelector(state => state.auth);


    let adviceClass = '';
    if(box.id === 2){
        adviceClass = ' defaultButtonAnimation';
    }

    return (
        <div className={"shopBoxContainerNutaku nutakuBox-" + box.id + "_" + box.first_payment}>

            {(box.id === 2) ?
                <div className={'shopBest'}></div>
                :
                <div></div>
            }

            <div className={"shopButtonOpenNutaku shopButtonOpenNutaku_" + box.id + adviceClass} onClick={async () => {
                if (isLoading) {
                    return;
                }
                setIsLoading(true);
                if (!config.isAndroid) {
                    try {
                        const result = await NutakuPaymentBrowserService.start(box);

                        if (result) {
                            await updateUser();
                        }
                    } finally {
                        setIsLoading(false);
                    }
                }else{
                    NutakuPaymentBrowserService.startAndroid(box);
                }


            }}></div>


        </div>
    );
};


export default NutakuBox;
